module.exports = __webpack_public_path__ + "img/ethical-apparel-africa.47e89b0d.png";